export interface SpecialGroup {
  title: string;
  desc: string;
  articleIds: string[];
}

export interface Special {
  id: string;
  title: string;
  cover: string;
  intro: string;
  reason: string;
  tag: string;
  updatedAt: string;
  groups: SpecialGroup[];
  related: string[];
}

export const specials: Special[] = [
  {
    id: 's1',
    title: '城市更新观察',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20city%20renewal%20district%20with%20new%20park%20and%20renovated%20buildings%2C%20warm%20autumn%20light%2C%20editorial%20urban%20photography&width=1200&height=675&seq=sp-01&orientation=landscape',
    intro:
      '从老旧小区改造到公共空间焕新，城市更新正在悄悄改变我们每天走过的街道。本专题带你走近一线现场，看看变化如何发生。',
    reason:
      '汇集政策解读、案例观察与居民访谈，系统呈现城市更新背后的思路，是了解城市发展方向的一手素材。',
    tag: '深度策划',
    updatedAt: '2026-10-11',
    groups: [
      {
        title: '政策与方向',
        desc: '梳理最新举措与目标，理解城市更新的整体脉络。',
        articleIds: ['n1', 'n5', 'n3'],
      },
      {
        title: '现场与案例',
        desc: '走进改造后的社区，感受居民生活的真实变化。',
        articleIds: ['n6', 'l6', 'n2'],
      },
    ],
    related: ['s3', 's2'],
  },
  {
    id: 's2',
    title: '国潮新势力',
    cover:
      'https://readdy.ai/api/search-image?query=elegant%20chinese%20style%20design%20objects%20with%20silk%20and%20porcelain%20on%20warm%20background%2C%20editorial%20product%20photography&width=1200&height=675&seq=sp-02&orientation=landscape',
    intro:
      '当传统文化遇见年轻表达，国潮不再只是一个词，而是融入服饰、家居与日常美学的真实选择。',
    reason:
      '从设计语言到消费趋势，多角度解读国潮的走红逻辑，适合关注文化与消费的读者集中阅读。',
    tag: '文化热点',
    updatedAt: '2026-10-10',
    groups: [
      {
        title: '风格与文化',
        desc: '看懂传统元素如何在现代设计中重生。',
        articleIds: ['e4', 'e3', 'e6'],
      },
      {
        title: '消费与趋势',
        desc: '年轻人为何愿意为国潮买单。',
        articleIds: ['e1', 'e5', 'n2'],
      },
    ],
    related: ['s4', 's1'],
  },
  {
    id: 's3',
    title: 'AI 时代生存指南',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20workspace%20with%20interactive%20ai%20displays%20and%20soft%20blue%20light%2C%20editorial%20technology%20photography&width=1200&height=675&seq=sp-03&orientation=landscape',
    intro:
      '人工智能正快速融入工作与生活。与其焦虑，不如先弄懂它能做什么、又该注意什么。',
    reason:
      '把技术原理、实用场景与风险提醒整合在一起，帮助你用更从容的心态拥抱新技术。',
    tag: '科技前沿',
    updatedAt: '2026-10-11',
    groups: [
      {
        title: '工具与效率',
        desc: '把智能助手变成真正好用的帮手。',
        articleIds: ['t1', 't4', 't2'],
      },
      {
        title: '产业与趋势',
        desc: '看懂技术演进背后的方向与机会。',
        articleIds: ['t5', 't3', 't6'],
      },
    ],
    related: ['s1', 's4'],
  },
  {
    id: 's4',
    title: '秋冬健康生活节',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20autumn%20healthy%20lifestyle%20flatlay%20with%20fruits%20tea%20and%20blanket%2C%20editorial%20wellness%20photography%2C%20warm%20tones&width=1200&height=675&seq=sp-04&orientation=landscape',
    intro:
      '天气转凉，从饮食到作息，从居家到出行，一份实用清单陪你舒舒服服过秋冬。',
    reason:
      '精选健康防护与生活服务内容，覆盖家庭高频需求，随手一翻就能用上。',
    tag: '生活服务',
    updatedAt: '2026-10-09',
    groups: [
      {
        title: '健康防护',
        desc: '科学养生，把身体照顾好。',
        articleIds: ['l1', 'l4', 'l5'],
      },
      {
        title: '居家与出行',
        desc: '让日常生活更省心更舒适。',
        articleIds: ['l2', 'l3', 'l6'],
      },
    ],
    related: ['s2', 's3'],
  },
];